document.addEventListener("DOMContentLoaded", function () {
  // Select all review-reveal-btn buttons
  const review_spec_buttons = document.querySelectorAll(".reveal-specs-reveal-btn");

  review_spec_buttons.forEach((button) => {
    // Listen for a click event on each button
    button.addEventListener("click", function () {
      const img = this.querySelector("img");
      const currentSrc = img.getAttribute("src");

      // Toggle between the two image sources
      if (
        currentSrc ===
        "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/arrow-up-right.svg?v=1727054826"
      ) {
        img.setAttribute(
          "src",
          "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/exit-blue.svg?v=1727056438"
        );
      } else {
        img.setAttribute(
          "src",
          "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/arrow-up-right.svg?v=1727054826"
        );
      }
    });
  });
  
  const revealSpecButtons = document.querySelectorAll(".reveal-specs-reveal-btn");

  // Add event listener to each button
  revealSpecButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const card = button.closest(".reveal-specs-reveal-card");
      card.classList.toggle("revealed");
    });
  });
  
  // Select all review-reveal-btn buttons
  const review_changing_buttons = document.querySelectorAll(".review-reveal-btn");

  review_changing_buttons.forEach((button) => {
    // Listen for a click event on each button
    button.addEventListener("click", function () {
      const img = this.querySelector("img");
      const currentSrc = img.getAttribute("src");

      // Toggle between the two image sources
      if (
        currentSrc ===
        "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/arrow-up-right.svg?v=1727054826"
      ) {
        img.setAttribute(
          "src",
          "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/exit-blue.svg?v=1727056438"
        );
      } else {
        img.setAttribute(
          "src",
          "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/arrow-up-right.svg?v=1727054826"
        );
      }
    });
  });

  const revealButtons = document.querySelectorAll(".review-reveal-btn");

  // Add event listener to each button
  revealButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const card = button.closest(".review-reveal-card");
      card.classList.toggle("revealed");
    });
  });

  var modalWhy = document.getElementById("videoModal");
  var whyBtn = document.querySelector(".watch-video-btn");
  var whyCloseBtn = document.querySelector(".close-btn");

  // Open modal on button click, if the button exists
  if (whyBtn && modalWhy) {
    whyBtn.addEventListener("click", function () {
      modalWhy.style.display = "flex";
    });
  }
  
  // Close modal on close button click, if the close button exists
  if (whyCloseBtn && modalWhy) {
    whyCloseBtn.addEventListener("click", function () {
      modalWhy.style.display = "none";
    });
  }
  
  // Close modal when clicking outside of modal content
  if (modalWhy) {
    window.addEventListener("click", function (event) {
      if (event.target == modalWhy) {
        modalWhy.style.display = "none";
      }
    });
  }

  /*
  var videoButtons = document.querySelectorAll(".videos-section-video-btn");
  var modals = document.querySelectorAll(".modal");
  var closeButtons = document.querySelectorAll(".close-btn");

  // Open modal when clicking the video button
  videoButtons.forEach(function (btn, index) {
    btn.addEventListener("click", function () {
      var modal = document.getElementById(`videoModal-${index + 1}`);
      if (modal) {
        modal.style.display = "flex";
      }
    });
  });

  // Close modal on close button click
  closeButtons.forEach(function (closeBtn, index) {
    closeBtn.addEventListener("click", function () {
      var modal = document.getElementById(`videoModal-${index + 1}`);
      if (modal) {
        modal.style.display = "none";
      }
    });
  });
  */
  const modals = document.querySelectorAll(".modal");
  const videoButtons = document.querySelectorAll(".videos-section-video-btn");
  const closeButtons = document.querySelectorAll(".close-btn");

  // Open modal and play video on video button click
  videoButtons.forEach((button, index) => {
    button.addEventListener("click", function () {
      const modal = document.getElementById(`videoModal-${index + 3}`);
      
      // If a modal doesn't exist for this button, stop right here.
      if (!modal) {
        return; 
      }
  
      const iframe = modal.querySelector("iframe");
      if (iframe) { // This check is now safe because we know `modal` exists
        modal.style.display = "flex";
        const videoId = button.parentElement.getAttribute("data-video-id");
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }
    });
  });

  // Function to close modal and stop video playback
  function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = "none";
      const iframe = modal.querySelector("iframe");
      if (iframe) {
        iframe.src = ""; // Reset src to stop the video
      }
    }
  }

  // Close modal on close button click
  closeButtons.forEach((button, index) => {
    button.addEventListener("click", function () {
      closeModal(`videoModal-${index + 3}`);
    });
  });

  // Close modal when clicking outside the modal content
  window.addEventListener("click", function (event) {
    closeButtons.forEach((_, index) => {
      const modalId = `videoModal-${index + 3}`;
      const modal = document.getElementById(modalId);
      if (event.target === modal) {
        closeModal(modalId);
      }
    });
  });

  // Close modal when clicking outside the modal content
  modals.forEach(function (modal) {
    window.addEventListener("click", function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    });
  });

  /*
  const countDownDate = new Date("Sep 21, 2024 22:00:00").getTime();

  // Update the countdown every 1 second
  const x = setInterval(function () {
    // Get current date and time
    const now = new Date().getTime();

    // Find the distance between now and the countdown date
    const distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the elements with id="days", "hours", "minutes", "seconds"
    // document.getElementById("hours").textContent = hours
    //   .toString()
    //   .padStart(2, "0");
    // document.getElementById("minutes").textContent = minutes
    //   .toString()
    //   .padStart(2, "0");
    // document.getElementById("seconds").textContent = seconds
    //   .toString()
    //   .padStart(2, "0");
    // document.getElementById("hours2").textContent = hours
    //   .toString()
    //   .padStart(2, "0");
    // document.getElementById("minutes2").textContent = minutes
    //   .toString()
    //   .padStart(2, "0");
    // document.getElementById("seconds2").textContent = seconds
    //   .toString()
    //   .padStart(2, "0");

    // If the countdown is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("hours").textContent = "00";
      document.getElementById("minutes").textContent = "00";
      document.getElementById("seconds").textContent = "00";
      document.getElementById("hours2").textContent = "00";
      document.getElementById("minutes2").textContent = "00";
      document.getElementById("seconds2").textContent = "00";
    }
  }, 1000);
  */

  const countDownDate = new Date("Sep 21, 2024 22:00:00").getTime();

  // Update the countdown every 1 second
  const x = setInterval(function () {
    const now = new Date().getTime();
    const distance = countDownDate - now;
  
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    // Safely update elements if they exist
    const hoursEl = document.getElementById("hours");
    const minutesEl = document.getElementById("minutes");
    const secondsEl = document.getElementById("seconds");
  
    if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, "0");
    if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, "0");
    if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, "0");
  
    const hoursEl2 = document.getElementById("hours2");
    const minutesEl2 = document.getElementById("minutes2");
    const secondsEl2 = document.getElementById("seconds2");
  
    if (hoursEl2) hoursEl2.textContent = hours.toString().padStart(2, "0");
    if (minutesEl2) minutesEl2.textContent = minutes.toString().padStart(2, "0");
    if (secondsEl2) secondsEl2.textContent = seconds.toString().padStart(2, "0");
  
    // If the countdown is finished, reset the values to "00"
    if (distance < 0) {
      clearInterval(x);
      [hoursEl, minutesEl, secondsEl, hoursEl2, minutesEl2, secondsEl2].forEach((el) => {
        if (el) el.textContent = "00";
      });
    }
  }, 1000);

  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });

  const faq2Items = document.querySelectorAll(".faq2-item");

  faq2Items.forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });

  const featuresItems = document.querySelectorAll(".features-item");

  featuresItems.forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });

  const reviewCards = document.querySelectorAll(".review-card");

  reviewCards.forEach((card) => {
    const preview = card.querySelector(".review-preview");
    preview.addEventListener("click", () => {
      card.classList.toggle("expanded");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const circles = document.querySelectorAll(".color-circle");
  const image = document.getElementById("color-image");

  const colorToImageMap = {
    "14181B": "black-bike-color-image.png",
    "00ABE8": "blue-bike-color-image.png",
    B8A1D7: "purple-bike-color-image.png",
    D5BB81: "tan-bike-color-image.png",
    white: "white-bike-color-image.png",
  };

  circles.forEach((circle) => {
    circle.addEventListener("click", () => {
      circles.forEach((c) => {
        if (c.style.backgroundColor == "white") {
          c.classList.remove("active");
          c.style.borderColor = "#D2D2D2";
          c.style.boxShadow = "none";
        } else {
          c.classList.remove("active");
          c.style.borderColor = "transparent";
          c.style.boxShadow = "none";
        }
      });

      if (circle.dataset.color == "white") {
        circle.classList.add("active");
        circle.style.borderColor = "white";
        circle.style.boxShadow = `0 0 0 2px #D2D2D2`;
      } else {
        circle.classList.add("active");
        circle.style.borderColor = "white";
        circle.style.boxShadow = `0 0 0 2px #${circle.dataset.color}`;
      }

      // Change the image based on the selected color
      const selectedColor = circle.dataset.color;
      image.src =
        `https://cdn.shopify.com/s/files/1/0229/0735/5214/files/${colorToImageMap[selectedColor]}?v=1726722875` ||
        "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/blue-bike-color-image.png?v=1726722875";
    });
  });
});

// const circles = document.querySelectorAll(".color-circle");
// const image = document.getElementById("color-image");

// const colorToImageMap = {
//   "14181B":
//     "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/black-bike-color-image.png?v=1726722875",
//   "00ABE8":
//     "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/blue-bike-color-image.png?v=1726722875",
//   B8A1D7:
//     "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/purple-bike-color-image.png?v=1726722875",
//   D5BB81:
//     "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/tan-bike-color-image.png?v=1726722875",
//   white:
//     "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/white-bike-color-image.png?v=1726722875",
// };

// circles.forEach((circle) => {
//   circle.addEventListener("click", () => {
//     console.log(circle);
//     circles.forEach((c) => {
//       if (c.style.backgroundColor == "white") {
//         c.classList.remove("active");
//         c.style.borderColor = "#D2D2D2";
//         c.style.boxShadow = "none";
//       } else {
//         c.classList.remove("active");
//         c.style.borderColor = "transparent";
//         c.style.boxShadow = "none";
//       }
//     });

//     if (circle.dataset.color == "white") {
//       circle.classList.add("active");
//       circle.style.borderColor = "white";
//       circle.style.boxShadow = `0 0 0 2px #D2D2D2`;
//     } else {
//       // Add 'active' class to clicked circle and apply styles
//       circle.classList.add("active");
//       circle.style.borderColor = "white";
//       circle.style.boxShadow = `0 0 0 2px #${circle.dataset.color}`;
//     }

//     // Change the image based on the selected color
//     // const selectedColor = circle.dataset.color;
//     // image.src =
//     //   "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/" + colorToImageMap[selectedColor] || "-bike-color-image.png?v=1726722875";

//     // Change the image based on the selected color
//     const selectedColor = circle.dataset.color;
//     image.src =
//       colorToImageMap[selectedColor] ||
//       "https://cdn.shopify.com/s/files/1/0229/0735/5214/files/blue-bike-color-image.png?v=1726722875";
//   });
// });

/*
$(document).ready(function () {
  $(".owl-carousel").owlCarousel({
    center: true,
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    stagePadding: 50,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });
});
*/
